import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    bannerShow: null,
    bannerClose: null,
    //
    //
    setBannerMessage: ["message"],
    clearBannerMessage: null,
    closeMessage: ["message"],
    parsedMenuItems: ["res"],

    getLoyaltyMilestones: ["sfid"],
    getLoyaltyMilestonesLoading: null,
    getLoyaltyMilestonesSuccess: ["res"],
    getLoyaltyMilestonesFailure: ["error"],
    //
    setBlogsCategoryList: ["res"],

    getMessages: ["sfid"], // NOT REQUIRED BUT COULD BE IMPLEMENTED => ['sfid', 'type_c', 'active_c'],
    getMessagesLoading: null,
    getMessagesSuccess: ["res", "sfid"],
    getMessagesFailure: ["error", "sfid"],
    //
    getCenters: null, // NOT REQUIRED BUT COULD BE IMPLEMENTED => ['city__c', 'zipcode__c', 'state__c'],
    getCentersLoading: null,
    getCentersSuccess: ["res"],
    getCentersFailure: ["error"],
    //
    getCentersForMobile: null,
    getCentersForMobileLoading: null,
    getCentersForMobileSuccess: ["res"],
    getCentersForMobileFailure: ["error"],
    //
    getGenders: null,
    getGendersLoading: null,
    getGendersSuccess: ["res"],
    getGendersFailure: ["error"],
    //
    getCountries: null,
    getCountriesLoading: null,
    getCountriesSuccess: ["res"],
    getCountriesFailure: ["error"],
    //
    getAllStates: null,
    getAllStatesLoading: null,
    getAllStatesSuccess: ["res"],
    getAllStatesFailure: ["error"],

    getLanguages: null,
    getLanguagesLoading: null,
    getLanguagesSuccess: ["res"],
    getLanguagesFailure: ["error"],

    getLoyaltyAchievementBadges: null,
    getLoyaltyAchievementBadgesLoading: null,
    getLoyaltyAchievementBadgesSuccess: ["res"],
    getLoyaltyAchievementBadgesFailure: ["error"],

    getPhoneTypes: null,
    getPhoneTypesLoading: null,
    getPhoneTypesSuccess: ["res"],
    getPhoneTypesFailure: ["error"],

    getEthnicityOptions: null,
    getEthnicityOptionsLoading: null,
    getEthnicityOptionsSuccess: ["res"],
    getEthnicityOptionsFailure: ["error"],

    saveContactForm: ["formData"],
    saveContactFormLoading: null,
    saveContactFormSuccess: ["res"],
    saveContactFormFailure: ["error"],

    getRedeemPaused: null,
    getRedeemPausedLoading: null,
    getRedeemPausedSuccess: ["res"],
    getRedeemPausedFailure: ["error"],

    getVendorRedeemPaused: null,
    getVendorRedeemPausedLoading: null,
    getVendorRedeemPausedSuccess: ["res"],
    getVendorRedeemPausedFailure: ["error"],

    drupalMenuFetch: ["menuType"],
    drupalMenuFetchLoading: ["menuType"],
    drupalMenuFetchSuccess: ["res", "menuType"],
    drupalMenuFetchFailure: ["error", "menuType"],

    getDrupalHomepage: null,
    getDrupalHomepageLoading: null,
    getDrupalHomepageSuccess: ["res"],
    getDrupalHomepageFailure: ["error"],

    getDrupalNavigation: null,
    getDrupalNavigationLoading: null,
    getDrupalNavigationSuccess: ["res"],
    getDrupalNavigationFailure: ["error"],

    getPatientTestimonials: ["refType"],
    getPatientTestimonialsLoading: null,
    getPatientTestimonialsSuccess: ["res"],
    getPatientTestimonialsFailure: ["error"],

    getFormsPage: ["formType"],
    getFormsPageLoading: ["formType"],
    getFormsPageSuccess: ["res", "formType"],
    getFormsPageFailure: ["error", "formType"],

    getCustomPage: ["slug"],
    getCustomPageLoading: null,
    getCustomPageSuccess: ["res", "slug"],
    getCustomPageFailure: ["error", "slug"],

    getPromotionalBanner: ["slug"],
    getPromotionalBannerLoading: null,
    getPromotionalBannerSuccess: ["res", "slug"],
    getPromotionalBannerFailure: ["error", "slug"],

    getRegistrationPage: ["formType"],
    getRegistrationPageLoading: ["formType"],
    getRegistrationPageSuccess: ["res", "formType"],
    getRegistrationPageFailure: ["error", "formType"],

    getLocationsPage: ["slug"],
    getLocationsPageLoading: null,
    getLocationsPageSuccess: ["res", "slug"],
    getLocationsPageFailure: ["error", "slug"],

    getCenterDetailsPage: ["centerSfid"],
    getCenterDetailsPageLoading: null,
    getCenterDetailsPageSuccess: ["res", "centerSfid"],
    getCenterDetailsPageFailure: ["error", "centerSfid"],

    getPostLoginPage: ["slug"],
    getPostLoginPageLoading: null,
    getPostLoginPageSuccess: ["res", "slug"],
    getPostLoginPageFailure: ["error", "slug"],

    getMobileScreenData: ["slug"],
    getMobileScreenDataLoading: null,
    getMobileScreenDataSuccess: ["res", "slug"],
    getMobileScreenDataFailure: ["error", "slug"],

    getOnboardingScreenData: null,
    getOnboardingScreenDataLoading: null,
    getOnboardingScreenDataSuccess: ["res"],
    getOnboardingScreenDataFailure: ["error"],

    getBlogsPage: ["slug"],
    getBlogsPageLoading: null,
    getBlogsPageSuccess: ["res", "slug"],
    getBlogsPageFailure: ["error", "slug"],

    getNewsPage: ["slug"],
    getNewsPageLoading: null,
    getNewsPageSuccess: ["res", "slug"],
    getNewsPageFailure: ["error", "slug"],
  },
  { prefix: "PUBLIC_CONTENT_" }
);

export const PublicContentTypes = Types;

export default Creators;
